module.exports = __webpack_public_path__ + "static/assets/ec20ef153dd2ce7a0072192330decd9d.svg";